/*
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-15 16:29:45
 * @Description: 
 */
import { defineStore } from 'pinia';
import { Dialog } from 'quasar';
import Cookies from 'js-cookie';

// ↓ 这是权限信息在 localStorage 中保存的键名 
export const sAuthKey = 'auth';
const iPrefixLength = 5;
let t01 = 0;

export const useAuthStore = defineStore(sAuthKey, {
    state: () => {
        return {
            accessToken: '', // 持久化 token 值
        };
    },
    actions: {
        setToken(accessToken: string) {
            this.accessToken = enCodeToken(accessToken);
        },
        cleanToken() {
            this.accessToken = '';
        },
    },
    getters: {
        // 👇 查询解密后的 token 值
        trueToken(oState){
            return deCodeToken(oState.accessToken);
        },
    },
    persist: {
        storage: persistedState.localStorage,
        beforeRestore: (ctx) => {
            if (import.meta.server) return;
            if (1 && t01){
                // ↓ 此值应为正数才属正常，即先存值，后取值
                const iGap = (Date.now() - t01) / 1000;
                const method = iGap > 0 ? 'log' : 'error';
                console[method]('time gap:', iGap, 's');
            }
            if (0 && import.meta.dev){
                console.log(`Store "${ctx.store.$id}" 即将初始化(恢复持久化的值)↓\n🎀`, ctx.store.trueToken);
            }
        },
    },
});

// ↓ 编码，防止 token 被“明文” 保存在 localStorage 中 
export function enCodeToken(accessToken, toSave=false){
    if (!accessToken) return '';
    let sPrefix = Date.now().toString(36);
    sPrefix = sPrefix.slice(iPrefixLength * -1); // 取尾部的 x 个字符
    const sResult = btoa(sPrefix + accessToken);
    if (toSave){
        t01 = Date.now();
        const sNewVal = JSON.stringify({
            accessToken: sResult,
        });
        localStorage.setItem(sAuthKey, sNewVal);
        try{
            // ↓ 此处出错无妨，一般是在刷新时 store 尚未建立，但新值会被成功写入 localstorage，并被读取被应用 
            const oAuth = useAuthStore();
            oAuth.accessToken = sResult;
        }catch(err){
            console.log("can not store up new token");
        }
    }
    return sResult;
}

// ↓ 查询服务器一侧推到客户端的 token 值 
export function getServerSideTK(){
    if (import.meta.server) return '';
    let sResult = Cookies.get(sTokenKey); 
    // ↑ 原本经此是可以顺利取值的 
    // ↑ 一些情况下，如本站点做为 iframe 位于其它域名下时，将无法顺利取得 cookie 值 
    // ↑ 除非指定 sameSite 为宽松模式，但此手段恐因高版本浏览器政策收紧而失效 
    if (!sResult && import.meta.client){
        // ↓ 所以在服务器一侧也会记录 tk 到 input[type=hidden] 然后在客户端取值 
        const oInput = document.querySelector(`input#${sTokenKey}`);
        sResult = oInput?.['value'] || '';
    }
    return sResult; 
}

// 👇 查询 token（会返回解码后的值）
export function deCodeToken(str=''):string{
    if (import.meta.server) return '';
    if (!str){
        try{
            const oAuth = JSON.parse(localStorage[sAuthKey]) || {};
            str = oAuth.accessToken;
        }catch(err){
            return '';
        }
    }
    if (!str) return '';
    try{
        const sResult = atob(str).slice(iPrefixLength);
        if (0 && import.meta.dev){
            console.log('🎀 TK value' + sResult);
        }
        return sResult;
    }catch(err){
        return '';
    }
}

interface DestroyConfig {
    showTips?: boolean;
    reload?: boolean;
    // ↓ 重要说明：这是要删除的目标值（旧 token)，如果当前保存的值不是目标值则跳过
    // ↓ 因为有可能先有旧 token 报错，后有 au 值转换的新 token 被写入，此新 token 不应被删除
    target?: string; 
}

// 👇 销毁（删除）token 值 
export function destroyToken(config:DestroyConfig={}){
    if (import.meta.server) return;
    const {showTips, reload, target} = config;
    if (target && (target != deCodeToken())){
        console.warn('Should not delete token 💥');
        return;
    }
    // 01 先清空 storage
    localStorage.removeItem(sAuthKey);
    try{
        // 02 再清空 pinia（页面刷新后立即执行此行或将导致报错）
        useAuthStore().cleanToken();
    }catch(err){
        console.log("Caught error while remove token:\n", err);
    }
    // ↓ 无提示：按需刷新，完成任务
    if (!showTips) {
        // ↓ 一定要打印，防止难以追踪刷新原因 
        reload && console.log('收到指令要求 reload() ☢️');
        reload && location.reload();
        return;
    }
    // ↓ 有提示：弹出提示 -> 按需刷新 
    const { $i18n } = useNuxtApp();
    const $t = $i18n?.t;
    if (!$t) {
        return;
    }
    // ↓ 提示用户登录状态失效，点击确定后刷新页面 
    Dialog.create({
        dark: true,
        title: $t('Note'),
        message: $t('commonInfo.tokenNoValid'),
        persistent: true,
    }).onOk(() => {
        console.log('OK');
        reload && location.reload();
    });
}



